module.exports = __webpack_public_path__ + "img/icon-tracking-boat.776ecef3.svg";